export const hearingStatusReqChecker = hearingType => {
  const rules = {
    appeal_jurisdiction: ['ip_adminappeal'],
    charges: ['ip_235', 'ip_238', 'ip_240'],
    expedited_removal_outcome: ['ip_235', 'ip_238', 'ip_241'],
    fear_expressed: ['ip_235', 'ip_238', 'ip_241', 'ip_unknown'],
    fear_block: ['ip_235', 'ip_238', 'ip_241'],
    federal_action: ['ip_fedaction'],
    immigration_judge: ['ip_235', 'ip_238', 'ip_240', 'ip_241'],
    removal_outcome: ['ip_240', 'ip_informal', 'ip_unknown', 'ip_adminappeal', 'ip_fedaction'],
  }

  return {
    appeal_jurisdiction: rules.appeal_jurisdiction.includes(hearingType),
    charges: rules.charges.includes(hearingType),
    expedited_removal_outcome: rules.expedited_removal_outcome.includes(hearingType),
    fear_expressed: rules.fear_expressed.includes(hearingType),
    fear_block: rules.fear_block.includes(hearingType),
    federal_action: rules.federal_action.includes(hearingType),
    immigration_judge: rules.immigration_judge.includes(hearingType),
    removal_outcome: rules.removal_outcome.includes(hearingType),
  }
}
